import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const ArrowLeftIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue5c4'}</MuiIcon>
    );
}
